import React, { lazy } from "react"
import {
  CONFIDENTIALITY_VIEW,
  CONTACT_VIEW,
  EDIT_FARM_PROFILE_VIEW,
  EDIT_MY_PROFILE_VIEW,
  FAQ_VIEW,
  NOTIFICATION_PREFERENCES_VIEW,
  SETTINGS_LIST_VIEW,
  TERMS_VIEW,
  TUTORIAL_VIEW,
  COMPANY_INFO_VIEW,
} from "@/features/settings-account/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const SettingsPage = lazy(
  () =>
    import("@/features/settings-account/views/settings-page/settings-page.tsx"),
)
const NotificationPreferences = React.lazy(
  () =>
    import(
      "@/features/settings-account/views/notification-preferences/notification-preferences"
    ),
)
const SettingsConfidentiality = React.lazy(
  () =>
    import(
      "@/features/settings-account/views/settings-confidentiality/settings-confidentiality"
    ),
)
const SettingsContact = React.lazy(
  () =>
    import(
      "@/features/settings-account/views/settings-contact/settings-contact"
    ),
)
const SettingsFaq = React.lazy(
  () => import("@/features/settings-account/views/settings-faq/settings-faq"),
)
const SettingsTerms = React.lazy(
  () =>
    import("@/features/settings-account/views/settings-terms/settings-terms"),
)
const SettingsTutorial = React.lazy(
  () =>
    import(
      "@/features/settings-account/views/settings-tutorial/settings-tutorial"
    ),
)
const UserProfileWrapper = React.lazy(
  () =>
    import(
      "@/features/settings-account/views/user-profile/user-profile-wrapper"
    ),
)
const CompanyInfoPage = React.lazy(
  () => import("@/features/settings-account/views/company-info/company-info"),
)
const FarmProfilePage = React.lazy(
  () => import("@/features/settings-account/views/farm-profile/farm-profile"),
)

export const settingsRoutes = [
  {
    path: SETTINGS_LIST_VIEW,
    element: <SettingsPage />,
  },
  {
    path: EDIT_FARM_PROFILE_VIEW,
    element: <FarmProfilePage />,
  },
  {
    path: COMPANY_INFO_VIEW,
    element: <CompanyInfoPage />,
  },
  {
    path: FAQ_VIEW,
    element: <SettingsFaq />,
  },
  {
    path: EDIT_MY_PROFILE_VIEW,
    element: <UserProfileWrapper />,
  },
  {
    path: TUTORIAL_VIEW,
    element: <SettingsTutorial />,
  },
  {
    path: CONFIDENTIALITY_VIEW,
    element: <SettingsConfidentiality />,
  },
  {
    path: CONTACT_VIEW,
    element: <SettingsContact />,
  },
  {
    path: TERMS_VIEW,
    element: <SettingsTerms />,
  },
  {
    path: NOTIFICATION_PREFERENCES_VIEW,
    element: <NotificationPreferences />,
  },
]

const MOBILE_SETTINGS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: settingsRoutes,
  },
]

const DESKTOP_SETTINGS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: settingsRoutes,
  },
]

export const getSettingsRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_SETTINGS_ROUTES : MOBILE_SETTINGS_ROUTES
}
